<div class="container single-view" id="view-product-customization">
  <div class="row">
    <div class="col-12 mb-4 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/product-customisations" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'PRODUCT_CUSTOMIZATIONS.BTN_BACK_TO_PRODUCT_CUSTOMIZATION' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-baseline justify-between gap-4">
        <div class="title-wr flex flex-wrap items-center">
          <div data-testid="productcustomisation-item">
            <h1 data-testid="section-item" class="section-title mb-3">{{ 'PRODUCT_CUSTOMIZATIONS_SINGLE_VIEW.PRODUCT_CUSTOMIZATIONS_DETAILS' | translate }}</h1>
            <div>
              <h2 data-testid="element-item" class="element-title flex items-center gap-2">
                <span data-testid='productcustomisation-name'>{{ productCustomization.name | defaultValue }}</span>
              </h2>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap justify-between gap-y-4 self-end">
          <div id="complementary-details" class="flex flex-wrap"></div>
          <div id="actions-wr" class="flex flex-wrap items-stretch justify-end gap-3">
            @if (allowModifyProductCustomisation) {
              <button data-testid='productcustomisation-edit-btn' class="btn primary-btn" (click)="goToEditProductCustomization()">{{ 'PRODUCT_CUSTOMIZATIONS_SINGLE_VIEW.BTN_EDIT' | translate }}</button>
            }
            @if (delete) {
              <button data-testid='productcustomisation-delete-btn' class="btn red-btn" (click)="showDeleteDialog()">{{'PRODUCT_CUSTOMIZATIONS.BTN_DELETE' | translate }}</button>
            }
          </div>
        </div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-4 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <section class="row">
              <div class="col-12 col-sm-12 col-md-4 col-lg-3">
                <img [src]="productCustomization.imageUrl" class="w-100 mt-2 featured-image">
              </div>
              <div class="col-12 col-sm-12 col-md-8 col-lg-9">
                <h4 data-testid='productcustomisation-details' >{{ 'PRODUCT_CUSTOMIZATIONS_SINGLE_VIEW.DETAILS' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                <dl class="details-grid">
                  <dt data-testid='productcustomisation-label' class="label grid-cols-1 pt-3">{{ 'PRODUCT_CUSTOMIZATIONS_SINGLE_VIEW.PRODUCT' | translate }}</dt>
                  <dd class="value pt-3 pb-3">
                    @if (productCustomization.productId && allowViewProduct) {
                      <a data-testid='productcustomisation-product' [routerLink]="['/products', productCustomization.productId]" class="inline-flex items-center link">{{
                      productCustomization.productName | defaultValue }}</a>
                    } @else {
                      {{ productCustomization.productName | defaultValue }}
                    }
                  </dd>

                  <dt data-testid='productcustomisation-description-label' class="label grid-cols-1 pt-3">{{ 'PRODUCT_CUSTOMIZATIONS_SINGLE_VIEW.CUSTOMIZATION_DESCRIPTION' | translate }}</dt>
                  <dd data-testid='productcustomisation-description' class="value pt-3 pb-3">{{ productCustomization.description | defaultValue }}</dd>

                  @if (canViewPrice) {
                    <dt data-testid='productcustomisation-price-label' class="label grid-cols-1 pt-3">{{ 'PRODUCT_CUSTOMIZATIONS_SINGLE_VIEW.CUSTOMIZATION_PRICE' | translate }}</dt>
                  }
                  @if (canViewPrice) {
                    <dd data-testid='productcustomisation-price' class="value pt-3 pb-3">{{ productCustomization.price | defaultValue }}</dd>
                  }

                  <dt data-testid='productcustomisation-code-label' class="label grid-cols-1 pt-3">{{ 'PRODUCT_CUSTOMIZATIONS_SINGLE_VIEW.CUSTOMIZATION_CODE' | translate }}</dt>
                  <dd data-testid='productcustomisation-code' class="value pt-3 pb-3">{{ productCustomization.code | defaultValue }}</dd>

                  <dt data-testid='productcustomisation-comment-label' class="label grid-cols-1 pt-3">{{ 'PRODUCT_CUSTOMIZATIONS_SINGLE_VIEW.CUSTOMIZATION_COMMENT' | translate }}</dt>
                  <dd data-testid='productcustomisation-comment' class="value pt-3 pb-3">{{ productCustomization.comment | defaultValue }}</dd>

                </dl>
              </div>
              @if (showProductAttributeDetails && translatedProductAttributes.length) {
                <div class="col-12 col-sm-12 mt-4">
                  <h4 data-testid='product-productattribute-details'>{{ 'PRODUCT_SINGLE_VIEW.PRODUCT_ATTRIBUTES' | translate }}</h4>
                  <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                  <dl class="details-grid">
                    @for (attr of translatedProductAttributes; track attr) {
                      <dt class="label grid-cols-1 pt-3">
                        {{ attr.name | defaultValue }} @if (attr.changesOverTime) {
                        <i class="icon icon-clock ml-1"></i>
                      }
                    </dt>
                    <dd [attr.data-testid]="'product-productAttributes-' + (attr.code || 'unknown')"  class="value pt-3 pb-3">
                      {{ attr.value | defaultValue }}
                    </dd>
                  }
                </dl>
              </div>
            }
          </section>
          <!-- /main content -->
        </div>
      </div>
    </div>
  </div>
</div>
</div>

<!-- Delete product customisation -->
<dialog-reason  #dialog [title]="'MODALBOXES.TITLE_CONFIRM_DELETE_PRODUCT_CUSTOMIZATION'" (onClose)="deleteProductCustomization($event)"></dialog-reason>
